import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-sensors-dialog',
    templateUrl: './sensors-dialog.component.html',
    styleUrls: ['./sensors-dialog.component.scss']
})
export class SensorsDialogComponent implements OnInit {

    location: any = null;

    constructor(
        public dialogRef: MatDialogRef<SensorsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.location = data.location;
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }

}
